export function Container({ children, className = "" }) {
  return (
    <div className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 ${className}`}>
      {children}
    </div>
  );
}

export function Kicker({ children, className = "" }) {
  return (
    <span className={`text-[11px] font-semibold uppercase tracking-[0.25em] text-primary ${className}`}>
      {children}
    </span>
  );
}

export function SectionHeading({ kicker, title, sub, action, className = "" }) {
  return (
    <div className={`mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between ${className}`}>
      <div className="max-w-2xl">
        {kicker && <Kicker>{kicker}</Kicker>}
        <h2 className="mt-2 text-2xl font-normal tracking-tight text-foreground sm:text-3xl lg:text-4xl">
          {title}
        </h2>
        {sub && <p className="mt-3 text-sm leading-relaxed text-muted-foreground sm:text-base">{sub}</p>}
      </div>
      {action}
    </div>
  );
}

export function Stat({ label, value, valueClass = "" }) {
  return (
    <div className="min-w-0 overflow-hidden rounded-md border border-border bg-card p-4">
      <div className="truncate text-[10px] font-medium uppercase tracking-[0.16em] text-muted-foreground">{label}</div>
      <div className={`mt-1.5 num truncate text-base font-semibold text-foreground ${valueClass}`}>{value}</div>
    </div>
  );
}
